import React, { useEffect, useState } from "react";
import { AiOutlineClose } from "react-icons/ai";
import CandidateInterviewCard from "../interviewCard/interviewCard";
import { GetInterviewDetails } from "../../../apiServices";
import { MyModal } from "../../../utility";
import ModalContainer from "../../../components/modal_popup";

const InterviewCardModal = ({ open, onClose, interviewId, details }) => {
  if (!open) return null;

  return (
    <MyModal>
      <ModalContainer
        childComponent={<>
        <div >
            <div className="d-flex justify-content-between align-items-center">
          <p style={{ fontSize: "18px" }}>
            <b>Download Interview Card</b>
          </p>

          <button className="btn btn-danger" onClick={onClose}>
            <AiOutlineClose />
          </button>
        </div>

        <div style={{ height: "80vh", overflowY: "auto" }}>
          {details && (
            <CandidateInterviewCard
              interviewId={interviewId}
              interviewDetails={details}
            />
          )}
        </div>
        </div></>}
      />
    </MyModal>
  );
};

export default InterviewCardModal;